import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { PermissionGate } from "@/components/PermissionGate";
import { ApiKeysCard } from "@/modules/admin";

export default function AdminApiKeysPage() {
  const { t } = useTranslation();
  return (
    <AppLayout
      title={t("admin.apiKeys.pageTitle")}
      description={t("admin.apiKeys.pageDescription")}
    >
      <PermissionGate
        perm="org.update"
        fallback={
          <p className="card text-sm text-nb-text-2">{t("admin.noPermission")}</p>
        }
      >
        <ApiKeysCard />
      </PermissionGate>
    </AppLayout>
  );
}
